export default __webpack_public_path__ + "static/media/saint-pierre-sur-divesmini.8b6dfc29.jpg";